import { uuidv4 } from '../dcf-utility.js';
import DCFDialog from './dcf-dialog.js';

export default class DCFButtonToggleDialog {

    uuid = uuidv4();

    buttonElement = null;

    dialogId = null;

    dialogElement = null;

    constructor(buttonElement) {
        this.buttonElement = buttonElement;
        if (this.buttonElement.tagName !== 'BUTTON') {
            throw new Error('dcf-btn-toggle-dialog used on non-button element');
        }
        if (this.buttonElement.getAttribute('id') === '' || this.buttonElement.getAttribute('id') === null) {
            this.buttonElement.setAttribute('id', this.uuid.concat('-btn-toggle-dialog'));
        }

        this.dialogId = this.buttonElement.dataset.controls;
        if (this.dialogId === undefined || this.dialogId === '') {
            throw new Error('dcf-btn-toggle-dialog is missing dialog id');
        }

        this.dialogElement = document.getElementById(this.dialogId);
        if (this.dialogElement === null) {
            throw new Error('dcf-btn-toggle-dialog can not find matching dialog');
        }

        if (this.dialogElement.classList.contains('dcf-dialog-non-modal')) {
            this.buttonElement.setAttribute('aria-expanded', this.#isDialogOpen());
        } else {
            this.buttonElement.setAttribute('aria-haspopup', 'dialog');
        }

        this.#addEventListeners();
        this.buttonElement.classList.add('dcf-btn-toggle-dialog-initialized');
        this.buttonElement.removeAttribute('hidden');
        this.buttonElement.removeAttribute('disabled');

        this.buttonElement.dispatchEvent(new CustomEvent(DCFButtonToggleDialog.events('btnToggleDialogReady'), {
            detail: {
                classInstance: this,
            },
        }));
    }

    // The names of the events to be used easily
    static events(name) {
        const events = {
            btnToggleDialogReady: 'btnToggleDialogReady',
        };
        Object.freeze(events);

        return name in events ? events[name] : undefined;
    }

    #isDialogOpen() {
        return this.dialogElement.classList.contains('dcf-dialog-is-open');
    }

    #addEventListeners() {
        this.buttonElement.addEventListener('click', () => {
            this.dialogElement.dispatchEvent(new CustomEvent(DCFDialog.events('commandToggle'), {
                detail: {
                    'button': this.buttonElement,
                },
            }));
        });

        this.dialogElement.addEventListener(DCFDialog.events('dialogPreOpen'), () => {
            this.buttonElement.classList.add('dcf-dialog-open');
            if (this.dialogElement.classList.contains('dcf-dialog-non-modal')) {
                this.buttonElement.setAttribute('aria-expanded', true);
            }
        });

        this.dialogElement.addEventListener(DCFDialog.events('dialogPreClose'), () => {
            this.buttonElement.classList.remove('dcf-dialog-open');
            if (this.dialogElement.classList.contains('dcf-dialog-non-modal')) {
                this.buttonElement.setAttribute('aria-expanded', false);
            }
        });
    }
}
